import React, { useEffect } from 'react';
import { Form, Input, Button, Modal, Switch, message } from 'antd';
import {
  useUpdateRegionMutation,
  useCreateRegionMutation,
} from 'reducers/masterData/region/api';

import { useErrorHandler } from 'common_components/ErrorContext';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { goBack } from 'connected-react-router';

const RegionFormComponent = (props) => {
  const { formData, isCreate, readonly } = props;
  const [form] = Form.useForm();
  const { setErrorData } = useErrorHandler();

  const dispatch = useDispatch();
  const [
    createRegion,
    {
      isSuccess: isSuccessCreating,
      isUninitialized: isUninitCreating,
      error: errorCreating,
      isLoading: isCreating,
    },
  ] = useCreateRegionMutation();

  const [
    updateRegion,
    {
      isSuccess: isSuccessUpdating,
      isUninitialized: isUninitUpdating,
      error: errorUpdating,
      isLoading: isUpdating,
    },
  ] = useUpdateRegionMutation();

  useEffect(() => {
    if (errorCreating) {
      setErrorData(errorCreating);
    }
    if (errorUpdating) {
      setErrorData(errorUpdating);
    }
  }, [errorUpdating, errorCreating, setErrorData]);

  useEffect(() => {
    if (
      (!isUninitUpdating && isSuccessUpdating) ||
      (!isUninitCreating && isSuccessCreating)
    ) {
      message.success('Data was successfully saved');
      if (isSuccessCreating) {
        dispatch(goBack());
      }
    }
  }, [
    isSuccessUpdating,
    isUninitUpdating,
    isSuccessCreating,
    isUninitCreating,
    dispatch,
  ]);

  const onFinish = (values) => {
    Modal.confirm({
      title: 'Confirm',
      icon: <ExclamationCircleOutlined />,
      content: 'Are you sure want to submit?',
      okText: 'Confirm',
      cancelText: 'Cancel',
      onOk: handleConfirmAction,
    });
  };

  const handleConfirmAction = () => {
    let validData = form.getFieldsValue(true);

    let postData = {
      id: formData && formData.id,
      ...validData,
    };

    if (isCreate) {
      createRegion(postData);
    } else {
      updateRegion(postData);
    }
  };

  return (
    <Form
      form={form}
      name='basic'
      labelCol={{
        span: 4,
      }}
      wrapperCol={{
        span: 10,
      }}
      style={{ padding: '20px' }}
      onFinish={onFinish}
      autoComplete='off'
    >
      <Form.Item
        wrapperCol={{
          offset: 12,
          span: 12,
        }}
      >
        <Button
          type='primary'
          htmlType='submit'
          loading={isCreating || isUpdating}
          disabled={readonly}
        >
          Submit
        </Button>
      </Form.Item>
      <Form.Item
        label='Name'
        name='name'
        initialValue={formData && formData.name}
        rules={[
          {
            required: true,
            message: 'Please input region name',
          },
        ]}
      >
        <Input disabled={readonly} placeholder={'Region name'} />
      </Form.Item>
      <Form.Item
        label='Abbreviation'
        name='abbreviation'
        initialValue={formData && formData.abbreviation}
        rules={[
          {
            required: true,
            message: 'Please input abbreviation',
          },
        ]}
      >
        <Input disabled={readonly} placeholder={'Abbreviation'} />
      </Form.Item>
      <Form.Item
        label='Is Active'
        name='is_active'
        initialValue={formData && formData.is_active}
        valuePropName='checked'
      >
        <Switch />
      </Form.Item>
    </Form>
  );
};

export default RegionFormComponent;
